import { useTranslation } from 'next-i18next';
import { PreviewCard } from '@/views/build/components/HoverPreview/PreviewCard';
import { type QuizType } from '@/views/build/components/type';
import { getQuizTypePreviewVideo } from '../consts/quizTypePreviewMedia';
import { QUIZ_TYPE_PREVIEWS } from '../consts/quizTypePreviews';
export const QuizTypePreviewCard = ({
  type
}: {
  type: QuizType;
}) => {
  const {
    t,
    i18n
  } = useTranslation(['build', 'common']);
  const {
    Icon,
    iconColor,
    labelKey,
    descriptionKey,
    useCaseKeys
  } = QUIZ_TYPE_PREVIEWS[type];
  const video = getQuizTypePreviewVideo(type, i18n.language);
  return <PreviewCard data-sentry-element="PreviewCard" data-sentry-component="QuizTypePreviewCard" data-sentry-source-file="QuizTypePreviewCard.tsx">
      {video ? <PreviewCard.Media src={video} /> : null}
      <PreviewCard.Heading data-sentry-element="unknown" data-sentry-source-file="QuizTypePreviewCard.tsx">
        <PreviewCard.Title icon={<Icon size="sm" fill={iconColor} />} data-sentry-element="unknown" data-sentry-source-file="QuizTypePreviewCard.tsx">
          {t(labelKey)}
        </PreviewCard.Title>
        <PreviewCard.Description data-sentry-element="unknown" data-sentry-source-file="QuizTypePreviewCard.tsx">{t(descriptionKey)}</PreviewCard.Description>
      </PreviewCard.Heading>
      <PreviewCard.Tags items={useCaseKeys.map(key => t(key))} data-sentry-element="unknown" data-sentry-source-file="QuizTypePreviewCard.tsx" />
    </PreviewCard>;
};